import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {SettingLinksN as SettingLinks} from "components/settings/SettingLinks";
import { PageHeaderV2 } from "components/PageHeader";
import WithLoading from "components/Hoc/WithLoading";
import { useCustomHistory } from "hooks";
import { Logout } from "store/actions";
import useQueryParam from "../hooks/useQueryParam";
import EditUserProfile from "pages/profile/EditUserProfile";
import { useDineIn } from "../hooks";

//TODO: requires cleanup

const Setting = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const queryParam = useQueryParam();
  const router = useCustomHistory();

  // const [settings, setSettings] = useState();
  const [isEditProfile, setIsEditProfile] = useState(false);
  
  const { DomainType } = useSelector((state) => state.AppReducer);
  const { brandInfo: Brand } = useSelector(
    (state) => state?.brandStorageReducer
  );

  const isMounted = useRef(false);
  const { goBack, goToHome } = useDineIn();


  const handleAllOrders = () => {
    router(
      `/dine-in/my-orders`,
      `/${params.domainName}/dine-in/my-orders`,
      DomainType,
      null,
      `?${queryParam}`
    );
  };
  
  const handleLogout = () => {
    window.sessionStorage.clear();
    localStorage.removeItem(Brand?.brand?._id);
    // localStorage.clear();
    localStorage.setItem("logoutEvent", Date.now().toString()); 
    dispatch(Logout.logout());
    goToHome();
  };
  //TODO: Edit Profile route is not working, need to fix it
  const handleEditProfile = () => {
    setIsEditProfile(true);
    // router(
    //   `/dine-in/auth/edit-profile?${queryParam}`,
    //   `/${params.domainName}/dine-in/auth/edit-profile?${queryParam}`,
    //   DomainType
    // );
  };

  useEffect(() => {
    const element = document.querySelector(".system-container");
    if (element && isMounted.current) {
      // Store the original height
      const originalHeight = element.style.getPropertyValue("height");
  
      // Set our custom height with !important
      if(isEditProfile){
        element.style.setProperty("height", originalHeight, "important");
      }else{
        element.style.setProperty("height", "auto", "important");
      }
  
      // Cleanup: restore original on unmount
      return () => {
        if (originalHeight) {
          element.style.setProperty("height", originalHeight, "important");
        } else {
          element.style.removeProperty("height");
        }
      };
    }
  }, [isMounted, isEditProfile]);

  return (
    <WithLoading>
         {params && (
          <div ref={isMounted}>
          <PageHeaderV2
          containerStyleProps={{
            style: {
              zIndex: 100,
              position: "relative",
            },
          }}
          headerStyleProps={{
            className: "p-6",
          }}
          pageTitle={isEditProfile ? "Edit Profile" : "User Settings"}
          onGoBack={isEditProfile ? ()=>setIsEditProfile(false) :()=>goBack()}
          hideAuth={true}
        />
        
            {isEditProfile ? 
            <EditUserProfile setUserInfoModal={()=>setIsEditProfile(false)} isOpenUserInfoModal={isEditProfile}/>
            :
            <div className="p-6 mt-3">
            <SettingLinks
              handleAllOrders={handleAllOrders}
              handleLogout={handleLogout}
              handleEditProfile={handleEditProfile}
            />
            </div>
}
          </div>
        )}
    </WithLoading>
  );
};

export default Setting;
